module.exports = __webpack_public_path__ + "static/media/Arrow.2f02c704.svg";